module.exports = __webpack_public_path__ + "static/media/12UNCTAD9.4088daff.jpg";